module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "with-content": true,
      "max-width": '80%'
    },
    on: {
      "close": _vm.close
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.saving
    }
  }), _vm._v(" "), _c('main', [_c('section', {
    staticClass: "first-section"
  }, [_c('div', {
    staticClass: "plano-info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentTrad.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$trad.common.brand) + " : " + _vm._s(_vm.plano.brand.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$trad.common.planogram) + " : " + _vm._s(_vm.plano.name))])]), _vm._v(" "), _c('div', {
    staticClass: "pdf-name"
  }, [_c('label', [_vm._v(" Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pdfName),
      expression: "pdfName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pdfName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pdfName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "second-section"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentTrad.printQuality))]), _vm._v(" "), _c('RadioInput', {
    attrs: {
      "label": _vm.QUALITIES.low.label,
      "value": _vm.QUALITIES.low.value,
      "name": 'printQuality'
    },
    model: {
      value: (_vm.printQuality),
      callback: function($$v) {
        _vm.printQuality = $$v
      },
      expression: "printQuality"
    }
  }), _vm._v(" "), _c('RadioInput', {
    attrs: {
      "label": _vm.QUALITIES.high.label,
      "value": _vm.QUALITIES.high.value,
      "name": 'printQuality'
    },
    model: {
      value: (_vm.printQuality),
      callback: function($$v) {
        _vm.printQuality = $$v
      },
      expression: "printQuality"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "third-section"
  }, [(_vm.hasAreas) ? _c('CheckBox', {
    attrs: {
      "label": _vm.currentTrad.overviewPage
    },
    model: {
      value: (_vm.frontPage),
      callback: function($$v) {
        _vm.frontPage = $$v
      },
      expression: "frontPage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasAreas) ? _c('CheckBox', {
    attrs: {
      "label": _vm.currentTrad.shadesPage
    },
    model: {
      value: (_vm.shadesPage),
      callback: function($$v) {
        _vm.shadesPage = $$v
      },
      expression: "shadesPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "label": _vm.currentTrad.infoPage
    },
    model: {
      value: (_vm.planoInfoLastPage),
      callback: function($$v) {
        _vm.planoInfoLastPage = $$v
      },
      expression: "planoInfoLastPage"
    }
  })], 1), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.canExport
    },
    on: {
      "click": _vm.exportPdf
    }
  }, [_vm._v(" " + _vm._s(_vm.$trad.common.exportPDF))])], 1)]), _vm._v(" "), (_vm.plano) ? _c('InfoPagePdf', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "InfoPagePdf",
    attrs: {
      "plano": _vm.plano
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee2a03e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/ModalExportPdf/index.vue
// module id = 3174
// module chunks = 0